import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GuestGuard } from '@readsavor/auth';
import { ROUTES } from './routes.js';

export const RouteGuestGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  const handleAuthenticated = () => {
    // 用户已认证，重定向到主页
    navigate(ROUTES.HOME.path);
  };

  return <GuestGuard onAuthenticated={handleAuthenticated}>{children}</GuestGuard>;
};
